import { NavSubItem } from '../../models/nav-sub-item';

export class DefaultNavSubItem extends NavSubItem {}
